import { IPurchaserRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetPurchaserUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IPurchaserRepositoryResponse> {
    return this.lookupRepository.getPurchasers();
  }
}
